import { useState } from "react";

const perks = [
  { icon: "ri-time-line", text: "每天固定时段更新热榜" },
  { icon: "ri-money-cny-circle-line", text: "全程免费，不设付费墙" },
  { icon: "ri-user-forbid-line", text: "无需注册即可浏览" },
];

export default function UpdateCta() {
  const [enabled, setEnabled] = useState(false);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-14 md:px-6 md:py-16">
        <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100 px-6 py-10 md:px-12 md:py-14">
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-primary-200/50 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-20 left-10 h-56 w-56 rounded-full bg-accent-100/70 blur-3xl" />

          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-12">
            <div className="lg:col-span-7">
              <h2 className="font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
                每天更新提醒 · 有新的瓜第一时间知道
              </h2>
              <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
                开启后页面会记住你的选择，每次打开首页都会优先展示当天最热的内容。
                这只是一个浏览偏好，不会上传任何信息。
              </p>

              <div className="mt-6 flex flex-wrap items-center gap-3">
                <button
                  type="button"
                  onClick={() => setEnabled((prev) => !prev)}
                  className={
                    enabled
                      ? "inline-flex h-12 shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-accent-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
                      : "inline-flex h-12 shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
                  }
                >
                  <i
                    className={
                      enabled
                        ? "ri-notification-3-fill w-4 h-4 flex items-center justify-center text-base"
                        : "ri-notification-3-line w-4 h-4 flex items-center justify-center text-base"
                    }
                  />
                  {enabled ? "已开启每日提醒" : "开启每日提醒"}
                </button>
                <a
                  href="#hot"
                  className="inline-flex h-12 shrink-0 items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-6 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  直接去看热榜
                </a>
              </div>
            </div>

            <div className="lg:col-span-5">
              <ul className="space-y-3">
                {perks.map((perk) => (
                  <li
                    key={perk.text}
                    className="flex items-center gap-3 rounded-md border border-background-200 bg-background-50 p-4"
                  >
                    <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-700">
                      <i className={`${perk.icon} w-5 h-5 flex items-center justify-center text-lg`} />
                    </span>
                    <span className="text-sm font-medium text-foreground-800">{perk.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}